import React from 'react';
import { Grid, Button, makeStyles, Tooltip } from '@material-ui/core/';
import SettingsInputAntennaIcon from '@material-ui/icons/SettingsInputAntenna';

const useStyles = makeStyles((theme) => ({
	assetLiveIndicatorBtn: {
		backgroundColor: 'gold',
		pointerEvents: 'none',
	},
}));

// reusable live status indicator component. used in (asset and artifact) components.
const LiveStatusIndicator = ({ message }) => {
	const classes = useStyles();
	return (
		<Tooltip title="live on Lowes.com" arrow={true} placement="top">
			<Grid item>
				<Button
					variant="outlined"
					size="small"
					startIcon={<SettingsInputAntennaIcon />}
					color="primary"
					className={classes.assetLiveIndicatorBtn}
				>
					{message}
				</Button>
			</Grid>
		</Tooltip>
	);
};

export default LiveStatusIndicator;
